import { TablePagination } from '@mui/material';
import React from 'react';


interface IProps {
  count: number;
  limit: number;
  page: number;
  onChange:(page:number) => void;
}

export default function CustomTablePagination(props:IProps) {

  return (
    <TablePagination
      component="div"
      count={props.count}
      rowsPerPage={props.limit}
      page={props.page}
      rowsPerPageOptions={[props.limit]}
      onPageChange={(e, page_number) => {
        props.onChange(page_number)
      }}
    />
  );
}